<template>
    <div>

        <!-- Status -->
        <sau-service-status :service="service"></sau-service-status>

        <!-- System Details -->
        <template v-if="Object.keys(service.custom).length > 0">
            <sau-service-common-system :service="service" class="pt-12"></sau-service-common-system>
        </template>

        <!-- Service Upgrade Check -->
        <sau-upgrade-check class="pt-12" v-if="display"></sau-upgrade-check>

        <!-- Pending Cancellation - now checked in sau-service-status -->
        <!-- <sau-cancellation-check class="pt-12"></sau-cancellation-check> -->

    </div>
</template>

<script>
import UpgradeCheck from '@js/components/utilities/_UpgradeCheck';

export default {
    props: ['service'],
    components: {
        'sau-upgrade-check': UpgradeCheck
    },
    data() {
        return {
            display: false,
        }
    },
    created() {
        // Lock down functionality if the service is suspended
        if(this.service.status.toLowerCase() != 'suspended') {
            this.display = true;
        }
    }
}
</script>

<style>
</style>
